import React, { useEffect, useState, useContext, useRef } from "react";
import { UserContext } from "../../context/UserContext";
import { LoaderContext } from "../../context/LoaderContext";
import "./Folder.css";

import folderIcon from "../../assets/images/folder.png";
import lockLight from "../../assets/images/lockLight.png";
import lockDark from "../../assets/images/lock.png";

import settingsIcon from "../../assets/images/settingsIcon.png";
import { API_URL } from "../../enviormentVariables";
import EditObjectModal from "../Modals/EditObjectModal/EditObjectModal";
import { MAX_CHARACTERS } from "../../enviormentVariables";
import { PATCH, POST, PUT, setAuth } from "../../utils/httpUtils";
import { Alert, GetObjectToken, isMobileDevice, Log, wait } from "../../utils/genericUtils";
import { AlertContext } from "../../context/AlertContext";
import ObjectPasswordModal from "../Modals/ObjectPasswordModal/object-password-modal";
import ThemeContext from "../../context/ThemeContext";

function Folder(props) {
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);

  const [objectId, setObjectId] = useState(props.objectId);
  const [initialRename, setInitialRename] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [listenerSet, setListenerSet] = useState(false);
  const [editModalActive, setEditModalActive] = useState(false);

  //locked flow
  const [objectPasswordModalActive, setObjectPasswordModalActive] = useState(false);

  const [unlocked, setUnlocked] = useState(GetObjectToken(props.objectId) ?? false);

  //refs
  const isUpdating = useRef(false);
  const mobileClickCount = useRef(0);

  let defaultFolders = ["Profile-Photo", "Other", "Public", "Videos", "Documents", "Photos", "Trash"];

  const { globalAlert } = useContext(AlertContext);
  const { theme } = useContext(ThemeContext);

  //all logic in this useEffect here is for the rename listener
  useEffect(() => {
    //do not assign these listeners if the object is in the trash
    let dir_parts = props.directory.split("/");
    if (props.locked || dir_parts[0].toLowerCase() === "trash" || dir_parts[1].toLowerCase() === "trash") {
      return;
    }

    let pTag = document.querySelector("#object-" + props.objectId + "-folder-name");
    let input = document.querySelector("#object-" + props.objectId + "-rename-input");

    if (props.objectId) setObjectId(props.objectId);

    if (props.objectId && props.DateCreated === props.DateModified && !defaultFolders.includes(props.folderName)) {
      Log("props.DateCreated === props.DateModified", props.DateCreated === props.DateModified);
      Log("date created:", props.DateCreated);
      Log("date modified:", props.DateModified);
      setInitialRename(true);
    } else {
      if (initialRename == true) {
        setInitialRename(false);
      }
    }

    if (initialRename == true) {
      input.focus();
    }

    const blurListener = async () => {
      if (!pTag) return;
      pTag.innerHTML = input.value;
      await UpdateFolderName(input.value);
      input.removeEventListener("blur", blurListener);
    };
    input.addEventListener("blur", blurListener);

    const enterListener = async (event) => {
      if (event.keyCode === 13) {
        Log(pTag);
        if (pTag) pTag.innerHTML = input.value;
        OnInPutFocusOut();
        await UpdateFolderName(input.value);
        input.removeEventListener("keydown", enterListener);
      }
    };
    //if not the initial rename just adds an enter key listener to the input
    input.addEventListener("keydown", enterListener);

    //adds a listener for double clicking folder name
    //to allow for the folder name to be edited relatively easily
    if (!listenerSet && objectId && !initialRename) {
      Log("setting dpuble click listener");
      let pTag = document.querySelector("#object-" + props.objectId + "-folder-name");
      let input = document.querySelector("#object-" + props.objectId + "-rename-input");
      const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        doubleClickEditName(pTag, input);
      };
      pTag.addEventListener("click", handleClick);
      setListenerSet(true);
    }
  }, [initialRename, objectId, props]);

  function truncateText(text) {
    if (text.length > MAX_CHARACTERS) {
      return text.substring(0, MAX_CHARACTERS) + "...";
    }
    return text;
  }

  async function UpdateFolderName(name) {
    if (isUpdating.current === true) return;
    isUpdating.current = true;
    let json = {
      objectId: objectId,
      objectName: name,
    };
    showloader();
    let response = await PATCH("/rename-object", json, user, [{ key: "x-file-dir", value: props.directory }]);
    isUpdating.current = false;
    hideloader();
    if (response.success) {
      props.forceUpdate();
    } else {
      Log(response);
    }
  }

  function doubleClickEditName(pTag, input) {
    setClickCount((prevCount) => {
      const newCount = prevCount + 1;
      if (newCount >= 2) {
        // If user clicks twice rapidly
        pTag.style.display = "none";
        input.style.display = "flex";
        input.focus();
      } else {
        setTimeout(() => {
          setClickCount(0);
        }, 500);
      }
      return newCount;
    });
  }

  function OnInPutFocusOut() {
    let pTag = document.querySelector("#object-" + props.objectId + "-folder-name");
    let input = document.querySelector("#object-" + props.objectId + "-rename-input");
    if (pTag) pTag.style.display = "block";
    input.style.display = "none";
    if (pTag) pTag.focus();
  }

  function showObjectModal() {
    setEditModalActive(true);
  }

  function closeShowObjectModal() {
    setEditModalActive(false);
  }

  function onFolderClick() {
    if (!props.locked || unlocked) {
      let isMobile = isMobileDevice();

      if (isMobile) {
        const nextClickCount = mobileClickCount.current + 1;
        mobileClickCount.current = nextClickCount;
        //reset count to zero if they do not double click in 1.5s
        wait(700, ()=> mobileClickCount.current = 0)
        if (nextClickCount < 2) return;
      }

      let dir;
      if (props.directory == "/") dir = "/" + props.folderName;
      else dir = props.directory + "/" + props.folderName;
      props.userClick(dir, GetObjectToken(props.objectId) ?? undefined);
    } else {
      setObjectPasswordModalActive(true);
    }
  }

  function OnUnlocked() {
    setUnlocked(true);
  }

  const lockIcon = theme === "light" ? lockDark : lockLight;

  return (
    <>
      <EditObjectModal
        isFolder={true}
        isPublicView={props.isPublicView}
        id={props.objectId}
        isActive={editModalActive}
        objectName={props.folderName}
        directory={props.directory}
        possibleDirectories={props.possibleDirectories}
        name={props.folderName}
        public={props.public}
        hidden={props.hidden}
        locked={props.locked}
        DateCreated={props.DateCreated}
        DateModified={props.DateModified}
        bytes={props.bytes}
        onCloseModal={() => {
          setEditModalActive(false);
        }}
        onClickOut={() => {
          setEditModalActive(false);
        }}
        forceUpdate={props.forceUpdate}
        isTrashBin={props.isTrashBin}
      />

      {/* Object Password Modal */}
      {props.locked && (
        <ObjectPasswordModal
          id={`object-password-modal-${props.objectId}`}
          icon={lockIcon}
          isActive={objectPasswordModalActive}
          onCloseModal={() => setObjectPasswordModalActive(false)}
          objectId={props.objectId}
          onUnlock={OnUnlocked}
        />
      )}

      <div className="folder-element" data-dir={props.directory}>
        {/* {props.locked && <img src={lockLight} alt="locked icon" className="locked-icon-overlay" />} */}
        <img src={props.locked && !unlocked ? lockIcon : folderIcon} onClick={onFolderClick} />
        <div className="relative-anchor">
          {/* Settings button */}
          {props.locked && !unlocked ? (
            <></>
          ) : (
            <button className="object-settings-button">
              <img onClick={showObjectModal} className="object-settings-button-icon" src={settingsIcon} />
            </button>
          )}
        </div>
        {initialRename ? (
          <>
            <p id={"object-" + props.objectId + "-folder-name"} className="folder-name hidden-rename">
              {truncateText(props.folderName)}
            </p>
            <input className="folder-rename-input" id={"object-" + props.objectId + "-rename-input"} type="text" defaultValue={props.folderName} />
          </>
        ) : (
          <>
            <p id={"object-" + props.objectId + "-folder-name"} className="folder-name">
              {truncateText(props.folderName)}
            </p>
            <input
              onBlur={OnInPutFocusOut}
              className="folder-rename-input hidden-rename"
              id={"object-" + props.objectId + "-rename-input"}
              type="text"
              defaultValue={props.folderName}
            />
          </>
        )}
      </div>
    </>
  );
}

export default Folder;
